import React from "react";
import { Checkbox, Text } from "@fluentui/react-components";
import {
  ACTION_LABELS,
  ENTITY_ACTIONS,
  ENTITY_LABELS,
  ENTITY_TYPES,
} from "./permissionConstants";

type Props = {
  selected: Set<string>;
  readOnly?: boolean;
  allChecked?: boolean;
  onToggle?: (permission: string, checked: boolean) => void;
  caption?: string;
};

const COLUMNS: string[] = [...ENTITY_ACTIONS];

export const PermissionGrid: React.FC<Props> = ({
  selected,
  readOnly,
  allChecked,
  onToggle,
  caption,
}) => {
  return (
    <div style={{ overflowX: "auto" }}>
      {caption && (
        <Text size={200} style={{ color: "#666", display: "block", marginBottom: 6 }}>
          {caption}
        </Text>
      )}
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left", padding: 6, borderBottom: "1px solid #eee" }}>
              Bereich
            </th>
            {COLUMNS.map((col) => (
              <th
                key={col}
                style={{ padding: 6, borderBottom: "1px solid #eee", whiteSpace: "nowrap" }}
              >
                {ACTION_LABELS[col] ?? col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ENTITY_TYPES.map((entity) => (
            <tr key={entity}>
              <td style={{ padding: 6 }}>{ENTITY_LABELS[entity]}</td>
              {COLUMNS.map((action) => {
                const key = `${entity}:${action}`;
                const checked = !!allChecked || selected.has(key);
                const disabled = !!readOnly || !!allChecked;
                return (
                  <td key={action} style={{ padding: 6, textAlign: "center" }}>
                    <Checkbox
                      checked={checked}
                      disabled={disabled}
                      onChange={(_, data) =>
                        onToggle && onToggle(key, !!data.checked)
                      }
                    />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PermissionGrid;
